import { useEffect, useState } from "react";
import { CircularGrid, Designation, DownloadIcon, Employee, Location, SearchSmall } from "../../utils/ReusableSVGs";
import { AddSiteEmployee, EmployeeDetailCard } from "./EmployeeManagementComponent";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { saveAs } from 'file-saver';
import { BASE_URL } from "../../config/axios";
import { handleErrorToast, sortProjects } from "../../utils/ReusableFunctions";
import * as XLSX from 'xlsx';
import { Projects } from "../../utils/ReusableFilters";


const SiteEmployeeDetails = () => {

    const companyId = sessionStorage.getItem("sitemanagement_project_sub_company");
    const projectID = sessionStorage.getItem("sitemanagement_project")

    const [project, setProject] = useState(projectID ? projectID : "null");
    const location = useLocation();

    const [projectList, setProjectList] = useState([]);

    const [subCompany, setSubCompany] = useState(companyId ? companyId : "null");
    const [subcompanyList, setSubCompanyList] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [employeeRole, setEmployeeRole] = useState("all");

    const [profession, setProfession] = useState("null");
    const [designation, setDesignation] = useState(null);
    const [designationList, setDesignationList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("null");
    const [buffer, setBuffering] = useState(false); //buffering logic
    const projectIdd = projectID ? projectID : location.state?.project?.id;

    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/configuration/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            // alert(error);
        }
    }

    const getproject = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/project_details/project`);
            // const response = await axios.get(
            //     sessionStorage.getItem('role') === 'AuthorityEngineer' ?
            //         `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
            //         : sessionStorage.getItem('role') === 'DataEntryOperator' ?
            //             `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
            //             : `${BASE_URL}/siteproject/projectfilterbysubcompany/${subCompany}/`
            // );
            const sortedList = sortProjects(response.data, "site_prcode");
            // setProjectList(response.data)
            setProjectList(sortedList)

        } catch (error) {
            // alert(error);
        }
    }

    // const getDesignation = async () => {
    //     try {
    //         const responsee = await axios.get(`${BASE_URL}/siteproject/designationfilterbysubcompany/${subCompany}/`)
    //         setDesignationList(responsee.data);
    //     } catch (error) {

    //     }
    // }

    useEffect(() => {

        getSubCompany();



    }, []);

    useEffect(() => {


        if (projectID === null) {
            getproject();
        }
        getproject();

        // getDesignation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subCompany])

    const getEmployee = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const ress = await axios.get(`${BASE_URL}/manpower/employeebyfilterss/${project}/${profession}/${selectedStatus}/${subCompany}/${designation}/${employeeRole}/`);
            const ress = await axios.get(`${BASE_URL}/manpower/employee/`);
            setEmployeeData(ress.data)


        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    }

    useEffect(() => {
        getEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project, profession, selectedStatus, subCompany, designation, employeeRole]);
    const [selectedNo, setNo] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    useEffect(() => {
        applyFilters();
    }, [selectedNo, employeeData]);

    const applyFilters = () => {
        let filteredData = employeeData;

        if (selectedNo !== "") {
            const lowercaseSelectedName = selectedNo?.toLowerCase();

            // Log to verify data

            filteredData = filteredData.filter(employee => {
                const lid = employee.emp_code?.toString()?.toLowerCase()?.includes(lowercaseSelectedName?.toString()) || employee?.name?.toLowerCase()?.includes(lowercaseSelectedName) || employee?.email?.toLowerCase()?.includes(lowercaseSelectedName);
                return lid;
            });
        }


        setFilteredData(filteredData);
    };

    const siteRole = sessionStorage.getItem("role")


    const handleClickDownload = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'EmployeeData');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(data, 'employee_data.xlsx');
    };

    return (
        <div>
            <div className="attendance-subcont">
                <div className="field-cont" style={{ maxWidth: '70vw' }}>
                    {siteRole === "SiteManagement" ? "" :
                        <div title="Company Filter" className="field-cont-div">
                            <CircularGrid />
                            <select
                                onChange={(e) => setSubCompany(e.target.value)}
                                value={subCompany}
                                className="attendance-input-field width-10vw   date-field"
                            // className="dropdown font-size-subheading  "
                            >
                                <option value="null">Sub Company</option>
                                {subcompanyList.map((company) => (
                                    <option value={company.id}>{company.title}</option>
                                ))}
                                ;
                            </select>

                            {/* <hr className="field-cont-hr" /> */}
                        </div>

                    }
                    {siteRole === "SiteManagement" ? "" :
                        <Projects value="id" toggleProject={project} setToggleProject={setProject} subcompany={subCompany} />
                    }

                    <div className="field-cont-div">
                        <Location />
                        <select className="attendance-input-field  date-field" type="text"
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="null">All</option>

                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>



                        </select>
                        <hr className="field-cont-hr" />
                    </div>


                    <div className="field-cont-div">
                        <Employee />
                        <select
                            className="attendance-input-field width-10vw date-field"
                            value={employeeRole}
                            onChange={(e) => setEmployeeRole(e.target.value)}
                        >

                            <option value="all">Select Employee Role </option>
                            <option value="Admin">Admin</option>
                            <option value="AuthorityEngineer">Authority Engineer</option>
                            <option value="DataEntryOperator">Coordinator</option>
                            <option value="Account">Account</option>
                            <option value="Hr">HR</option>
                            <option value="BD">BD</option>
                            <option value="Checker">Checker</option>
                            <option value="SiteManagement">Access Account</option>
                            <option value="Employee">Employee</option>
                            <option value="null">Persons </option>


                        </select>
                        <hr className="field-cont-hr" />
                    </div>




                    <div title='Search Filter' className="field-cont-div">
                        <SearchSmall />
                        <input className="attendance-input-field width-25vw"
                            placeholder='Employee Name/Emp code/ Email'
                            type="text"
                            value={selectedNo}
                            onChange={(e) => setNo(e.target.value)} />

                        <hr className="field-cont-hr" />
                    </div>

                    <div className="field-cont-div">
                        <CircularGrid />


                        <select
                            className="attendance-input-field width-10vw   date-field"
                            type="text"
                            value={profession}
                            onChange={(e) => setProfession(e.target.value)}
                        >
                            <option value="null"> Professional </option>
                            <option value="Key Professional">Key Professional</option>
                            <option value="Sub Professional">Sub Professional</option>
                            <option value="Support Staff">Support Staff</option>
                        </select>
                        <hr className="field-cont-hr" />
                    </div>

                    {/* <div title="Designation" className="field-cont-div">
                        <Designation />

                        <select
                            onChange={(e) => setDesignation(e.target.value)}
                            value={designation}
                            className="attendance-input-field width-10vw   date-field"
                        >
                            <option value="null">Designation</option>
                            {designationList.map((designation) => (
                                <option value={designation.id}>{designation.title}</option>
                            ))}
                            ;
                        </select>

                        <hr className="field-cont-hr" />
                    </div> */}
                </div>
                <div className="btn-cont">
                    <button className=" model-button-print" onClick={handleClickDownload}>
                        <DownloadIcon />
                    </button>
                    <AddSiteEmployee
                        projectId={project}
                        getSiteEmployee={getEmployee}
                        siteProjectList={projectList}
                        siteDepartmentList={designationList}
                        siteSubCompanyList={subcompanyList}
                        companyId={subCompany}

                    />


                </div>
            </div>
            <div style={{ maxHeight: '73vh' }}>
                {
                    buffer ? <div className="spinner-bgdatil"></div> :
                        <EmployeeDetailCard
                            data={filteredData}
                            getSiteEmployee={getEmployee}
                            siteDepartmentList={designationList}
                            siteProjectList={projectList}
                            siteSubCompanyList={subcompanyList} />}
            </div>


        </div>
    )

}


export {
    SiteEmployeeDetails
}